
import React from 'react';

interface IntegrationLogoProps {
  logoSrc: string;
  name: string;
  size?: number; // for future flexibility
  className?: string;
}

const IntegrationLogo: React.FC<IntegrationLogoProps> = ({ logoSrc, name, size = 32, className = "" }) => (
  <img
    src={logoSrc}
    alt={`${name} Logo`}
    className={`inline-block object-contain ${className}`}
    style={{ height: size, width: 'auto' }}
    loading="lazy"
    draggable={false}
  />
);

export default IntegrationLogo;
